import { HOMEPAGE_VERSION } from "../../../utils/homepageVersion";

/**
 * Code for each homepage. The same functions back the lazy components and the
 * background preload, so a preloaded chunk is the one React then renders.
 */
export const HOMEPAGE_LOADERS = {
  [HOMEPAGE_VERSION.NEW]: () => import("../../SPDashboard/SPDashboard"),
  [HOMEPAGE_VERSION.OLD]: () => import("../../HomePage/Index"),
};
